import { render } from "./FacturacionAlbaranes.vue?vue&type=template&id=8adfb934"
import script from "./FacturacionAlbaranes.vue?vue&type=script&lang=js"
export * from "./FacturacionAlbaranes.vue?vue&type=script&lang=js"

import "./FacturacionAlbaranes.vue?vue&type=style&index=0&id=8adfb934&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__